import { createContext } from "react"
import { getDefaultUserData, TAppUser } from "../modules/app-user/app-user"

export const AppUserContext = createContext<TAppUser>(getDefaultUserData());

export default AppUserContext;
